import React, { Component } from "react";
import { Row, Col, Table, Drawer, Button, Popconfirm } from "antd";
import { withRouter, Link } from "react-router-dom";
import { DeleteOutlined } from "@ant-design/icons";
import FileDownload from "js-file-download";
import PlusIcon from "../../../svg/svgicon/PlusIcon";
import ButtonLinkIcon from "../../../Components/MyComponent/ButtonLinkIcon";
import { API } from "../../../API/API";
import UserContext from "../../UserContext/UserContext";
import JoinWorkDocumentAdd from "./JoinWorkDocumentAdd";

class JoinWorkDocumentList extends Component {
  static contextType = UserContext;
  state = {
    joinworkid: this.props.joinworkid,
    isEdit: this.props.isEdit,
    data: [],
    showNewInputForm: false,
    selectedDocId: 0,
  };

  componentDidMount = () => {
    this.getData();
  };
  getData = () => {
    API.get("/getTenderDocList?joinworkid=" + this.state.joinworkid).then(
      (response) => {
        if (response.status === 200) {
          this.setState({
            data: response.data.retData,
          });
        }
      }
    );
  };
  onDownLoadFile = (sourceid, sourcetype, filename) => {
    API.get("/download?sourceid=" + sourceid + "&sourcetype=" + sourcetype, {
      responseType: "blob",
    }).then((response) => {
      if (response.status === 200) {
        FileDownload(response.data, filename);
      }
    });
  };
  showNewInputFormHandler = (show, docid) => {
    this.setState({
      showNewInputForm: show,
      selectedDocId: docid,
    });
    if (show === false) {
      this.getData();
    }
  };
  onDeleteFile = (sourceid, sourcetype) => {
    API.get("/deleteFile?sourceid=" + sourceid + "&sourcetype=" + sourcetype, {
      responseType: "blob",
    }).then((response) => {
      if (response.status === 200) {
        this.getData();
      }
    });
  };
  render() {
    const columns = [
      {
        title: "Код",
        dataIndex: "documentcode",
        key: "documentcode",
        width: "20%",
        align: "left",
        render: (text, record) => {
          return (
            <Button
              className="link"
              type="link"
              onClick={() => this.showNewInputFormHandler(true, record.docid)}
            >
              {record.documentcode}
            </Button>
          );
        },
      },
      {
        title: "хавсралт материалын нэр",
        dataIndex: "documentname",
        key: "documentname",
        width: "20%",
        align: "left",
      },
      {
        title: "Үүсгэсэн огноо",
        dataIndex: "created",
        key: "created",
        width: "10%",
        align: "left",
      },
      {
        title: "Үүсгэсэн хэрэглэгч",
        dataIndex: "createdby",
        key: "createdby",
        width: "10%",
        align: "left",
      },
      {
        title: "Төрөл",
        dataIndex: "doctypename",
        key: "doctypename",
        width: "10%",
        align: "left",
      },
      
      {
        title: "",
        dataIndex: "action",
        key: "action",
        width: "5%",
        align: "left",
        render: (text, record) => {
          return this.props.isEdit ? (
            <Popconfirm
              title="Уcтгахдаа итгэлтэй байна уу?"
              onConfirm={() => this.onDeleteFile(record.docid, "TenderDoc")}
            >
              <Button
                type="link"
                icon={<DeleteOutlined style={{ color: "red" }} />}
              />
            </Popconfirm>
          ) : null;
        },
      },
      {
        title: "Файл",
        dataIndex: "filename",
        key: "filename",
        width: "20%",
        align: "left",
        render: (text, record) => {
          return (
            <Button
              className="link"
              type="link"
              onClick={() =>
                this.onDownLoadFile(
                  record.sourceid,
                  record.sourcetype,
                  record.filename
                )
              }
            >
              {record.filename}
            </Button>
          );
        },
      },
    ];
    return (
      <div className="Container">
        <Row align="middle">
          <Col span={12}>
            <Row style={{ height: 56 }} justify="start" align="middle">
              <Col>
                <div className="HeaderLabel">4. Нэмэлт хавсралт, материал</div>
              </Col>
              <Col>
                <div className="divider"></div>
              </Col>
              <Col>
              {(this.context.permission.isAdmin === "1" ||  this.context.permission.isJWAdmin === "1")  ?  
                this.props.isEdit === true ?   
                <ButtonLinkIcon
                  onClick={() => this.showNewInputFormHandler(true, 0)}
                  icon={<PlusIcon />}
                  name="Хавсралт материал нэмэх"
                /> : null
              : null}
              </Col>
            </Row>
          </Col>
        </Row>

        <div id="member-list">
          <Table
            dataSource={this.state.data}
            columns={[
              {
                title: "№",
                dataIndex: "key",
                key: "key",
                width: "3%",
                render: (text, row, index) => (
                  <>{this.state.data.indexOf(row) + 1}</>
                ),
              },
              ...columns,
            ]}
            pagination={false}
            rowKey="documentid"
            scroll={{ y: 340 }}
          />
        </div>
        {(this.context.permission.isAdmin === "1" ||  this.context.permission.isJWAdmin === "1")  ?     
        <Drawer
          title="Хавсралт материал нэмэх"
          width="500px"
          placement="right"
          visible={this.state.showNewInputForm}
          onClose={() => this.showNewInputFormHandler(false, 0)}
          destroyOnClose={true}
          style
        >
          <JoinWorkDocumentAdd
            joinworkid={this.state.joinworkid}
            docid={this.state.selectedDocId}
            showForm={this.showNewInputFormHandler}
            isEdit={this.state.isEdit}
          ></JoinWorkDocumentAdd>
        </Drawer> 
        : null}
      </div>
    );
  }
}

export default withRouter(JoinWorkDocumentList);
